export const liyABVariant = {
  allCourse: 1,
  callNow: 2,
  menaUser: 3,
}

export const liyButtonData = {
  [liyABVariant.allCourse]: {
    content: "While you wait, get started on your IELTS journey",
    buttonText: "Explore Courses",
  },
  [liyABVariant.callNow]: {
    content: "Don't want to wait?",
    subContent: "Start a conversation with our expert right away.",
    buttonText: "Call Now",
  },
  [liyABVariant.menaUser]: {
    content:
      "While you wait, take our Band Predictor Test to predict your IELTS score now",
    buttonText: "Attempt Test Now",
  },
}
